<template>
    <div class="Instructions">
        <transition @enter="enter" @leave="leave">
            <div ref="container" class="Instructions__container">
                <div class="Instructions__title">Instructions</div>
                <div>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam fermentum ex arcu, a ultrices enim finibus a. Ut semper et leo ac scelerisque. Pellentesque placerat interdum nisl non faucibus.</div>

                <div class="Instructions__qrcode">   
                    <div class="Instructions__canvas" id="canvas"></div>
                    <div class="Instructions__url">memeath-v2.dpt.media/media/{{ room }}</div> 
                </div> 

            </div>
        </transition>
    </div>
</template>

<script>

export default {
    name: 'Instructions',
    props: [ 'room' ],
    data: ()=>({}),  
    beforeDestroy() {},
    created(){},
    mounted() {

        const qrCode = new QRCodeStyling({
            width: 300,
            height: 300,
            data: "https://meneath-v2.dpt.media/media/"+ this.room,
            image: require('@/commons/images/onf.png'),
            dotsOptions: {
                color: "#5b9b45",
                type: "rounded"
            },
            backgroundOptions: {
                color: "#fff",
            },
            imageOptions: {
                crossOrigin: "anonymous",
                margin: 20
            }
        });

        qrCode.append(document.getElementById("canvas"))

    },

    methods: {
        enter(done) { done() },
        leave(done) { done() },
    }
}
</script>

<style lang='stylus'>

@import '~@/commons/stylus/Media-queries'
@import '~@/config/Settings'

.Instructions
    position absolute
    width 100vw
    height 100vh
    top 0
    left 0
    z-index 1000
    display flex 
    align-items center
    justify-content center

    &__container 
        width 100%
        max-width 600px
        height 100%
        display flex 
        align-items center
        justify-content center
        flex-direction column
        text-align center

    &__title
        margin-bottom 32px

    &__qrcode
        display flex
        flex-direction column
        align-items center
        margin-top 32px

    &__canvas 
        width 120px
        padding 8px 8px 3px
        background white
        border-radius 8px
        margin-bottom 12px

        & canvas 
            width 100%

    &__url 
        background violet
        padding 4px 10px

</style>